import { login, logout, getInfo } from '@/api/login'
import { getRoleList } from '@/api/role'
import { getToken, setToken, removeToken } from '@/utils/auth'

export default {
  state: {
    token: getToken(),
    userInfo: null,
    roles: [],
    // userTypes: [],
    banks: [],
    menus: [],
    regionsInfo: [],
    commonUserTypeDialog: null, // 通道型卡主弹框
    employeeObj: {
      employeeId: null,
      employeeName: null,
      isClockIn: null
    },
  },
  mutations: {
    SET_STATE: (state, data) => {
      Object.keys(data).forEach(key => {
        state[key] = data[key]
      })
    },
    SET_EMPLOYEE_OBJ: (state, data) => {
      state.employeeObj = data
    },
  },
  actions: {
    Login({ commit }, userInfo) {
      const username = userInfo.username ? userInfo.username.trim() : null
      return new Promise((resolve, reject) => {
        login(username, userInfo.password, userInfo.captcha).then(res => {
          if (res.data.token) {
            // 移除 localStorage 的 loginToken 字段
            localStorage.removeItem("loginToken");

            setToken(res.data.token)
            commit('SET_STATE', { token: res.data.token })
          }
          resolve(res)
        }).catch(err => {
          reject(err)
        })
      })
    },
    GetInfo({ commit }) {
      return new Promise((resolve, reject) => {
        getInfo().then(res => {
          // 如果是通道型代理旗下卡主
          if (res.data.userType === 'customer' && res.data.commonUserType === 1) {
            removeToken(); // 清除 token 防止无法登入其他帐号
            commit('SET_STATE', { token: null, commonUserTypeDialog: true })
            return;
          }
          commit('SET_STATE', { userInfo: res.data })
          // 如果是限缩佣金
          if (res.data.roles.indexOf('limit_commission') !== -1) {
            // 移除 提现管理（withdraw）、佣金管理（commission）、佣金帐变明细（commissionChange）
            commit('SET_STATE', { menus: res.data.menu.filter(item => item.name !== 'withdraw' && item.name !== 'commission' && item.name !== 'commissionChange') })
          } else {
            commit('SET_STATE', { menus: res.data.menu })
          }
          commit('SET_STATE', { roles: res.data.roles })
          resolve(res)
        }).catch(err => {
          reject(err)
        })
      })
    },
    GetRoles({ commit }) {
      return new Promise((resolve, reject) => {
        getRoleList().then(res => {
          commit('SET_STATE', { roles: res.data })
          resolve(res)
        }).catch(err => {
          reject(err)
        })
      })
    },
    LogOut({ commit, state }) {
      return new Promise((resolve, reject) => {
        logout(state.token).then(() => {
          commit('SET_STATE', { token: '' })
          commit('SET_STATE', { roles: [] })
          commit('SET_STATE', { userTypes: [] })
          commit('SET_STATE', { banks: [] })
          commit('SET_STATE', { userInfo: null })
          // 移除 localStorage 的 loginToken 字段
          localStorage.removeItem("loginToken");

          removeToken()
          resolve()
        }).catch(err => {
          reject(err)
        })
      })
    },
    FedLogOut({ commit }) {
      return new Promise(resolve => {
        commit('SET_STATE', { token: '' })
        commit('SET_STATE', { roles: [] })
        commit('SET_STATE', { userTypes: [] })
        commit('SET_STATE', { banks: [] })
        commit('SET_STATE', { userInfo: null })
        // 移除 localStorage 的 loginToken 字段
        localStorage.removeItem("loginToken");

        removeToken()
        resolve()
      })
    }
  }
}


// WEBPACK FOOTER //
// ./src/store/modules/login.js